<template>
  <div>
    <div>
      <div class="form-group">
        <c-switcher v-model="form.familyStatus.show" label="Семейное положение" />
      </div>

      <transition name="slide">
        <div v-if="form.familyStatus.show" class="params">
          <div class="form-group">
            <c-switcher v-model="form.familyStatus.required" type="checkbox" label="Обязательное" />
          </div>
          <list-params
            :form="form.familyStatus"
            field-name="Семейное положение"
            :field-type="fieldType"
            @change="$emit('editDictionary', 'familyStatuses')"
          />
        </div>
      </transition>
    </div>

    <div class="form-group">
      <c-switcher v-model="form.hasChildren" label="Есть дети" />
    </div>
  </div>
</template>

<script>
import CSwitcher from "@/components/controls/switcher";
import ListParams from "@/pages/profile/form/components/ListParams";

export default {
  components: { CSwitcher, ListParams },
  props: ["form", "field", "fieldType"],
};
</script>

<style lang="scss" scoped>
.params {
  padding-left: 20px;

  padding-bottom: 25px;
}
</style>
